import React, { useState } from 'react';

const Accordion = ({ title = 'title', children, nested = false }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={`c-accordion ${nested ? 'c-accordion--nested' : ''}`}>
      <div
        className={`c-accordion__title${
          open ? ' c-accordion__title--active' : ''
        }`}
        onClick={() => setOpen((p) => !p)}
        dangerouslySetInnerHTML={{ __html: title }}
      ></div>

      <div
        className={`c-accordion__content${
          open ? ' c-accordion__content--active' : ''
        }`}
      >
        <div className="c-accordion__content__inner">{children}</div>
      </div>
    </div>
  );
};

export default Accordion;
